/* MYCÉA Care : fiche produit.
   Galerie, sélecteur d'offres, ajout au panier, barre mobile, upsell.
   L'ajout passe par /cart/add.js : c'est l'API Ajax officielle de Shopify,
   donc l'événement client product_added_to_cart part normalement et le pixel
   Meta continue de compter les ajouts au panier. */
(function () {
  'use strict';

  function euro(txt) { return (txt || '').trim(); }

  function brancher(racine) {
    if (!racine || racine.dataset.mcPret === '1') return;
    racine.dataset.mcPret = '1';

    /* ---------------- galerie ---------------- */
    var vues  = racine.querySelectorAll('[data-mc-vue]');
    var minis = racine.querySelectorAll('[data-mc-mini]');
    var ptsGal = racine.querySelectorAll('[data-mc-pr-pt]');
    var courante = 0;

    function montrer(i) {
      if (!vues.length) return;
      courante = (i + vues.length) % vues.length;
      vues.forEach(function (v) {
        v.classList.toggle('is-on', Number(v.getAttribute('data-mc-vue')) === courante);
      });
      minis.forEach(function (m) {
        var on = Number(m.getAttribute('data-mc-mini')) === courante;
        m.classList.toggle('is-on', on);
        if (on) { m.setAttribute('aria-current', 'true'); m.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
        else { m.removeAttribute('aria-current'); }
      });
      ptsGal.forEach(function (p, j) { p.classList.toggle('is-on', j === courante); });
    }

    minis.forEach(function (b) {
      b.addEventListener('click', function () { montrer(Number(b.getAttribute('data-mc-mini'))); });
    });

    ptsGal.forEach(function (p, j) { p.addEventListener('click', function () { montrer(j); }); });

    var prec = racine.querySelector('[data-mc-prec]');
    var suiv = racine.querySelector('[data-mc-suiv]');
    if (prec) prec.addEventListener('click', function () { montrer(courante - 1); });
    if (suiv) suiv.addEventListener('click', function () { montrer(courante + 1); });

    // glissement au doigt sur la photo principale
    var scene = racine.querySelector('.mc-pr__scene');
    if (scene && vues.length > 1) {
      var x0 = null;
      scene.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      scene.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) montrer(courante + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
    }

    /* ---------------- offres ---------------- */
    var form     = racine.querySelector('[data-mc-form]');
    var radios   = racine.querySelectorAll('[data-mc-offre]');
    var pxBouton = racine.querySelector('[data-mc-prix-bouton]');
    var bar      = racine.querySelector('[data-mc-bar]');
    var barPrix  = racine.querySelector('[data-mc-bar-prix]');
    var barOffre = racine.querySelector('[data-mc-bar-offre]');
    var barBtn   = racine.querySelector('[data-mc-bar-btn]');
    var err      = racine.querySelector('[data-mc-err]');
    var btnAjout = racine.querySelector('[data-mc-ajout]');
    if (!form || !radios.length) return;

    function choisie() {
      for (var i = 0; i < radios.length; i++) { if (radios[i].checked) return radios[i]; }
      return radios[0];
    }

    function rafraichir() {
      var r = choisie();
      if (!r) return;
      var prix = euro(r.getAttribute('data-prix'));
      if (pxBouton) pxBouton.textContent = prix ? ' · ' + prix : '';
      if (barPrix)  barPrix.textContent  = prix ? ' · ' + prix : '';
      if (barOffre) {
        var lab = r.closest('.mc-offre').querySelector('.mc-offre__t');
        barOffre.textContent = lab ? lab.textContent.trim() : '';
      }
      racine.querySelectorAll('.mc-offre').forEach(function (c) {
        c.classList.toggle('is-on', c.contains(r));
      });
    }

    radios.forEach(function (r) { r.addEventListener('change', rafraichir); });
    rafraichir();

    /* ---------------- ajout au panier ---------------- */
    function lignes() {
      var r = choisie();
      var vid = (r.getAttribute('data-variante') || '').trim();
      var qte = parseInt(r.getAttribute('data-quantite'), 10) || 1;
      // La variante dédiée n'existe pas encore : on retombe sur la variante
      // par défaut, en quantité. L'aperçu reste donc testable.
      if (/^\d{6,}$/.test(vid)) return [{ id: Number(vid), quantity: 1 }];
      return [{ id: Number(racine.dataset.varianteDefaut), quantity: qte }];
    }

    function apresAjout() {
      var type = racine.dataset.panierType;
      if (type === 'drawer') {
        var d = document.querySelector('cart-drawer');
        if (d && typeof d.open === 'function') {
          document.dispatchEvent(new CustomEvent('mycea:panier'));
          d.open();
          return;
        }
      }
      window.location.href = window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root + 'cart' : '/cart';
    }

    function ajouter(items, bouton) {
      if (err) { err.hidden = true; err.textContent = ''; }
      if (bouton) { bouton.classList.add('is-busy'); bouton.disabled = true; }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && res.j.description ? res.j.description : 'Ajout impossible');
          // Laisse à Shopify le temps d'envoyer « ajout au panier » aux pixels (Meta) avant de quitter la page :
          // une redirection immédiate coupait parfois l'envoi (mesuré le 2026-10-04).
          return new Promise(function (ok) { setTimeout(ok, 600); }).then(apresAjout);
        })
        .catch(function (e) {
          if (err) { err.textContent = e.message || "L'ajout au panier n'a pas fonctionné. Réessaie."; err.hidden = false; }
        })
        .finally(function () {
          if (bouton) { bouton.classList.remove('is-busy'); bouton.disabled = false; }
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      ajouter(lignes(), btnAjout);
    });
    if (barBtn) barBtn.addEventListener('click', function () { ajouter(lignes(), barBtn); });

    var upBtn = racine.querySelector('[data-mc-up-btn]');
    if (upBtn) {
      upBtn.addEventListener('click', function () {
        var v = Number(upBtn.getAttribute('data-variante'));
        if (v) ajouter([{ id: v, quantity: 1 }], upBtn);
      });
    }


    /* ---------------- avis, slide par slide ---------------- */
    var av = racine.querySelector('[data-mc-av]');
    if (av) {
      var slides = av.querySelectorAll('[data-mc-av-slide]');
      var points = av.querySelectorAll('[data-mc-av-pt]');
      var iAv = 0;
      function montrerAvis(i) {
        if (!slides.length) return;
        iAv = (i + slides.length) % slides.length;
        slides.forEach(function (s, j) {
          var on = j === iAv;
          s.classList.toggle('is-on', on);
          if (on) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
        });
        points.forEach(function (p, j) {
          var on = j === iAv;
          p.classList.toggle('is-on', on);
          p.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }
      points.forEach(function (p, j) { p.addEventListener('click', function () { montrerAvis(j); }); });
      var ap = av.querySelector('[data-mc-av-prec]'), as = av.querySelector('[data-mc-av-suiv]');
      if (ap) ap.addEventListener('click', function () { montrerAvis(iAv - 1); });
      if (as) as.addEventListener('click', function () { montrerAvis(iAv + 1); });
      var ax = null;
      av.addEventListener('touchstart', function (e) { ax = e.touches[0].clientX; }, { passive: true });
      av.addEventListener('touchend', function (e) {
        if (ax === null) return;
        var dx = e.changedTouches[0].clientX - ax;
        if (Math.abs(dx) > 40) montrerAvis(iAv + (dx < 0 ? 1 : -1));
        ax = null;
      }, { passive: true });
    }

    /* ---------------- barre mobile ---------------- */
    if (bar && 'IntersectionObserver' in window) {
      document.body.classList.add('mc-has-sticky-bar');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.hidden = en.isIntersecting; });
      }, { rootMargin: '-80px 0px 0px 0px' });
      io.observe(form);
    }
  }

  function init(racine) {
    (racine || document).querySelectorAll('[data-mc-produit]').forEach(brancher);
  }
  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  init();
})();
